import React, { useContext, useEffect, useMemo, useState } from "react";

import CameraFilterContext from "../../../CameraListing/CameraFilterContext";

import t from "../../../../../lib/translate";

import * as styles from "./range.module.less";
import { useIsTiny } from "../../../../../lib/hooks/mediaQueries";

export function Range({ filterKey, settings = {}, options }) {
    const isTiny = useIsTiny();
    const { active, replaceFilterOptionAction } =
        useContext(CameraFilterContext);
    const filterOptions = useMemo(
        () => [
            { label: "0", value: 0 },
            ...options//.filter(({ disabled }) => !disabled)
        ],
        [options]
    );

    const { labelTranslation } = settings;

    const filterOptionsLength = filterOptions.length;

    const min = 0;
    const max = filterOptionsLength - 1;

    const initialIndex = filterOptions.findIndex(({ active }) => active);

    const [storedValue, setStoredValue] = useState(
        filterOptions[initialIndex < 0 ? min : initialIndex]
    );
    const [value, setValue] = useState(initialIndex < 0 ? min : initialIndex);
    const [labelPos, setLabelPos] = useState(0);

    const updateValue = (event) => {
        const index = +event.target.value;
        setValue(index);
        setStoredValue(filterOptions[index]);
    };

    useEffect(() => {
        const activeIndex = filterOptions.findIndex(({ active }) => active);
        if (activeIndex === value) return;

        if (activeIndex < 0) {
            setValue(0);
            setStoredValue(filterOptions[0]);
            return;
        }

        setValue(active);
        setStoredValue(filterOptions[activeIndex]);
    }, [active]);

    let rangeWidth = isTiny ? 250 : 400;
    useEffect(() => {
        setLabelPos((rangeWidth / filterOptionsLength) * value);
    }, [value, filterOptionsLength]);

    return (
        <div className={styles.rangeContainer}>
            <span>{`${
                labelTranslation ? t(labelTranslation) : filterKey
            }`}</span>

            <div className={styles.inputContainer}>
                <label
                    htmlFor={filterKey}
                    style={{ left: `${labelPos.toString()}px` }}
                >
                    {storedValue?.label + " Hz" ?? ""}
                </label>
                <input
                    name={filterKey}
                    type="range"
                    min={min}
                    max={max}
                    step={1}
                    value={value}
                    onChange={updateValue}
                    onMouseUp={() =>
                        replaceFilterOptionAction(filterKey, storedValue.value)
                    }
                    style={{ width: `${rangeWidth.toString()}px` }}
                />
            </div>

            <div className={styles.rangeLabels}>
                <span>{filterOptions[0].label + " Hz"}</span>
                <span>
                    {filterOptions[filterOptionsLength - 1].label + " Hz"}
                </span>
            </div>
        </div>
    );
}
